import { useCrmUrl } from '@/utils/crm-url';

type DonorScheduleDonorLinkProps = {
  donorScheduleId: string;
  donorName: string;
};

export const DonorScheduleDonorLink = ({
  donorScheduleId,
  donorName,
}: DonorScheduleDonorLinkProps) => {
  const crmUrl = useCrmUrl();
  if (!crmUrl) {
    return donorName;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10081');
  url.searchParams.set(
    'extraqs',
    'formid=cf94e021-761e-4198-a8e4-61683662691d',
  );
  url.searchParams.set('id', `{${donorScheduleId}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {donorName}
    </a>
  );
};
